import React from "react"
import styled from "@emotion/styled"
import ThemeSelector from "src/components/ThemeSelector"
import Grid from "src/components/Grid"
import { globals, mq } from "src/styles"

const SectionWrapper = styled(ThemeSelector)`
	width: 100%;
	z-index: ${({ zIndex }) => zIndex};
	${({ padded, prevTheme, nextTheme, setTheme, isFirstSection }) =>
    padded !== false &&
    `
		${
      !isFirstSection
        ? `
			${
        setTheme === prevTheme
          ? `
				${globals.verticalSpacing("padding-top", 0.5)}
			`
          : `
				${globals.verticalSpacing("padding-top", 0.5)}
			`
      }
		`
        : `
			${
        setTheme !== "default"
          ? `
				${globals.verticalSpacing("padding-top", 0.5)}
			`
          : `
				${globals.verticalSpacing("padding-top", 0.5)}
			`
      }
		`
    }
		${
      setTheme === nextTheme
        ? `
			${globals.verticalSpacing("padding-bottom", 0.5)}
		`
        : `
			${globals.verticalSpacing("padding-bottom", 0.5)}
		`
    }
	`}

	// Add Card Section Logic
	${({ prevTheme, nextTheme, setTheme, isFirstSection, fullWidth }) => `
		${
      setTheme !== "default" && !fullWidth
        ? `

			border-radius: var(--card-border-radius);

			${
        nextTheme !== setTheme
          ? `
				''
			`
          : ""
      }

			${
        prevTheme !== setTheme && !isFirstSection
          ? `
''			`
          : ""
      }

			${
        nextTheme === setTheme
          ? `
				border-bottom-left-radius: 0;
				border-bottom-right-radius: 0;
			`
          : ""
      }

			${
        prevTheme === setTheme
          ? `
				border-top-left-radius: 0;
				border-top-right-radius: 0;
			`
          : ""
      }

			${mq.largeAndBelow} {
				margin-top: 0;
				margin-bottom: 0;
				border-radius: 0;
			}

		`
        : ""
    }
		${
      fullWidth && !isFirstSection
        ? `
	''
		`
        : ""
    }
	`}
`

const Section = ({
  children,
  setTheme,
  prevTheme,
  nextTheme,
  zIndex,
  buttons,
  padded,
  sectionid,
  className,
  isFirstSection,
  fullWidth,
  as,
  id,
}) => {
  return (
    <Grid
      small="[1]"
      // large={setTheme !== 'default' ? 'm [1] m' : '[1]'}
      large={!fullWidth ? "m [1] m" : "[1]"}
    >
      <SectionWrapper
        className={className}
        setTheme={setTheme}
        prevTheme={prevTheme}
        nextTheme={nextTheme}
        zIndex={zIndex}
        padded={padded}
        isFirstSection={isFirstSection}
        as={as || "section"}
        id={id}
        fullWidth={fullWidth}
      >
        {children}
      </SectionWrapper>
    </Grid>
  )
}

Section.defaultProps = {
  setTheme: "default",
  prevTheme: false,
  nextTheme: false,
  zIndex: 1,
  padded: true,
}

export default Section
